import { useMemo } from 'react';
import { MenuNavigationShellPage } from './MenuNavigationShellPage';
import type { AgendaRegistration } from './MenuNavigationShellPage';

/**
 * Kořenová plocha aplikace na `/`.
 * Zobrazuje menu a prázdnou plochu (PhoenixDesktop) – žádná agenda se neotevírá automaticky.
 * App-shell chrome, ne business slice, proto žije v `app/layout` vedle MenuNavigationShellPage.
 */
export function DesktopShellPage() {
  const agendas: AgendaRegistration[] = useMemo(() => [], []);

  return <MenuNavigationShellPage agendas={agendas} />;
}
